module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "pl-6-5"
    }
  }), _c('b', [_vm._v("Straight Strips")])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "pt1"
    }
  }, [_vm._v("SIDEWALK CHALK")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/6_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bck"
  }, [_c('p', {
    staticClass: "side1"
  }, [_c('b', [_vm._v("Finished Block:")]), _vm._v(" 16˝ × 16˝")]), _vm._v(" "), _c('p', {
    staticClass: "side2"
  }, [_c('b', [_vm._v("2½˝ × strips:")]), _vm._v(" 2 white, 4 print")]), _vm._v(" "), _c('p', {
    staticClass: "side2"
  }, [_c('b', [_vm._v("White fabric:")]), _vm._v(" 1 strip 6½˝ × WOF")]), _vm._v(" "), _c('p', {
    staticClass: "side2"
  }, [_c('b', [_vm._v("Solid fabric:")]), _vm._v(" 1 strip 6½˝ × WOF (Makes 3 blocks.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('i', [_vm._v("The cutting method that creates blocks from tubes of fabric is the nifty secret that makes this quilt come together with ease. It’s a study of complexity born of simplicity.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('i', [_vm._v("All seams are ¼˝.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Sew a 2½˝ print strip on either side of a 2½˝ white strip lengthwise to make a strip set. "), _c('b', [_vm._v("1A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/6_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Repeat to make a second strip set.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Pair a strip set with each of the 6½˝ wide strips and sew together along both long edges to make a tube. Repeat with the other pair. "), _c('b', [_vm._v("2A and 2B")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/6_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Use a ruler with a 45° guideline that has sides at least 9½˝ long. Line up the 45° line to the seam at the top. Make the first cut. Toss the scrap. "), _c('b', [_vm._v("3A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/6_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Slide the ruler down to the bottom line of stitching, moving along the cut edge of fabric. Make the second cut when the ruler’s 45° guideline sits on the stitching. "), _c('b', [_vm._v("3B")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/6_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Now return to the top line of stitching, moving the ruler along the newly cut edge. Continue in this fashion with both strip tubes. Each strip will yield 6 half-square triangles.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Square each half-square triangle to 8½˝ × 8½˝.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Arrange 2 of each type of half-square triangle as shown. "), _c('b', [_vm._v("4A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/6_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Sew the half-square triangles in rows first then sew the 2 rows together to form a block, nesting seams. Make a total of 3 blocks.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "pl-7-6"
    }
  }), _c('i', [_vm._v("Sidewalk Chalk Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/7_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Glow by Amy Butler for Rowan Bella Solids Breeze & Bella Solids White by Moda Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/7_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bck"
  }, [_c('p', {
    staticClass: "side1a"
  }, [_c('b', [_vm._v("Finished Quilt:")]), _vm._v(" 89˝ × 105˝")])]), _vm._v(" "), _c('p', {
    staticClass: "cap_h"
  }, [_vm._v("MATERIALS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("QUILT TOP: 1 roll of 2½˝ print strips")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("3½ yards of background fabric")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("2 yards of solid complementary fabric")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("BORDER: 1½ yards")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("BINDING: ¾ yard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("BACKING: 9½ yards-vertical seam(s) or 3¼ yards 108˝ wide")]), _vm._v(" "), _c('p', {
    staticClass: "cap_h"
  }, [_vm._v("CONSTRUCTION NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This quilt uses 30 blocks cut from 20 strip set tubes (10 white and 10 with complementary fabric). Borders are cut 5˝ wide.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eef36ba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0005_part-title-1.vue
// module id = 63
// module chunks = 0